export const referralCenterMarkup = String.raw`
<div class="view" id="view-referrals">
  <div class="ref-page-head">
    <div><h1 class="heading-1">Invite friends</h1></div>
    <p>After a friend’s first qualifying payment, you both get AI Create credits.</p>
  </div>
  <section class="ref-share-card" aria-labelledby="refShareTitle">
    <div><h2 id="refShareTitle">Your invite link</h2><p>Share this personal link. The first valid inviter is kept for 30 days.</p></div>
	    <div class="ref-link-row">
	      <input id="referralLink" type="text" readonly autocomplete="off" aria-label="Your invite link" value="Loading…">
	      <div class="ref-share-actions">
	        <button class="btn btn-outline" id="referralCopyButton" type="button">Copy link</button>
	        <button class="btn btn-outline" id="referralShareButton" type="button" hidden>Share</button>
	      </div>
	    </div>
    <p class="ref-reward-rule" id="referralRewardRule">Loading reward policy…</p>
  </section>
  <div class="ref-summary" aria-label="Referral summary">
    <div class="ref-stat"><strong id="referralInvitedCount">—</strong><span>Friends invited</span></div>
    <div class="ref-stat"><strong id="referralQualifiedCount">—</strong><span>Qualified</span></div>
    <div class="ref-stat"><strong id="referralRewardTotal">—</strong><span>Credits earned</span></div>
  </div>
  <section class="ref-list-card" aria-labelledby="refListTitle">
    <div class="ref-list-head"><div><h2 id="refListTitle">Your invitations</h2></div></div>
    <div id="referralInviteeList" class="ref-list"><div class="ref-empty">Loading invitations…</div></div>
    <button id="referralLoadMore" class="btn btn-outline ref-load-more" type="button" hidden>Load more</button>
  </section>
</div>`;
